import { Box, Stack, Typography } from '@mui/material';
import MultiplayerRoomSetup from '../components/MultiplayerRoomSetup';
import SinglePlayerRoomSetup from '../components/SinglePlayerRoomSetup';
import AdComponent from '../components/AdComponent';

function Home({ socket }) {
  // NOTE: The <head> tag should be in your public/index.html file, not here.
  // I've removed it from the component's return statement.

  return (
    <header className="App-header">
      <div>
        {/* Use MUI's Typography for responsive font sizes */}
        <Typography variant="h1" sx={{ fontSize: { xs: '3rem', md: '5rem' } }}>
          ChessBlindly
        </Typography>
        <Typography sx={{ fontSize: { xs: '1rem', md: '1.4rem' }, mb: 4 }}> {/* mb adds margin-bottom */}
          Play blindfold chess with your friends!
        </Typography>

        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          {/* This is the key change for responsiveness */}
          <Stack
            direction={{ xs: 'column', sm: 'row' }} // Stacks vertically on mobile, horizontally on larger screens
            spacing={{ xs: 2, sm: 4 }}           // Adjusts spacing for different screen sizes
            alignItems="center"
          >
            <MultiplayerRoomSetup socket={socket} />
            <SinglePlayerRoomSetup socket={socket} />
          </Stack>
        </Box>
        <AdComponent />
      </div>
    </header>
  );
}

export default Home;